// @flow

import { createContext } from 'react'
import type { Post } from '../templates/blog-post/types'

export const PostContext: React$Context<Post> = createContext<Post>({})

export default PostContext
